export const PLAYER_NAME_KEY = 'PlayerName';
export const PLAYER_AVATAR_KEY = 'PlayerAvatar';
export const PLAYER_DIFFICULTY_KEY = 'PlayerDifficulty';
export const GAME_SCORE_KEY = 'Quoridor3D';
